import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v35.6.1 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
var HistoryManager = /*#__PURE__*/function (_ref) {
  _inherits(HistoryManager, _ref);

  var _super = _createSuper(HistoryManager);

  function HistoryManager() {
    var _this;

    _classCallCheck(this, HistoryManager);

    _this = _super.apply(this, arguments), _this.history = [], _this.historyIndex = -1;
    return _this;
  }

  _createClass(HistoryManager, [{
    key: "add",
    value: function add(t) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      s || 0 === this.history.length ? (this.history = [t], this.historyIndex = 0) : (this.history = this.history.slice(0, this.historyIndex + 1), this.history.push(t), this.historyIndex++), this.emit("state-added");
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.historyIndex < this.history.length - 1;
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this.historyIndex > 0;
    }
  }, {
    key: "getCurrentState",
    value: function getCurrentState() {
      return this.history[this.historyIndex];
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.history.length;
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this.historyIndex;
    }
  }, {
    key: "getState",
    value: function getState(t) {
      return this.history[t];
    }
  }, {
    key: "redo",
    value: function redo() {
      var _this2 = this;

      return new Promise(function (t) {
        if (_this2.canRedo()) {
          _this2.historyIndex++;

          var s = _this2.getCurrentState();

          _this2.emit("state-change", s), t(s);
        }
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.history = [], this.historyIndex = -1;
    }
  }, {
    key: "setState",
    value: function setState(t) {
      return this.history[this.historyIndex] = t;
    }
  }, {
    key: "undo",
    value: function undo() {
      var _this3 = this;

      return new Promise(function (t) {
        if (_this3.canUndo()) {
          _this3.historyIndex--;

          var s = _this3.getCurrentState();

          _this3.emit("state-change", s), t(s);
        }
      });
    }
  }]);

  return HistoryManager;
}( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);

    this.listeners = new Map();
  }

  _createClass(_class, [{
    key: "removeListener",
    value: function removeListener(t, s) {
      var e = this.listeners.get(t);

      if (e && e.length) {
        var i = e.reduce(function (t, e, i) {
          return e === s ? t = i : t;
        }, -1);
        if (i >= 0) return e.splice(i, 1), this.listeners.set(t, e), !0;
      }

      return !1;
    }
  }, {
    key: "on",
    value: function on(t, s) {
      var _this4 = this;

      this.listeners.has(t) || this.listeners.set(t, []);
      var e = {
        callback: s,
        remove: function remove() {
          return _this4.removeListener(t, s);
        }
      };
      return this.listeners.get(t).push(e), e;
    }
  }, {
    key: "emit",
    value: function emit(t) {
      for (var _len = arguments.length, s = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        s[_key - 1] = arguments[_key];
      }

      var e = this.listeners.get(t);
      return !(!e || !e.length) && (e.forEach(function (t) {
        t.callback.apply(t, s);
      }), !0);
    }
  }]);

  return _class;
}());

export { HistoryManager as H };